import { Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { MDialog } from "src/ui/Dialog/MDialog"
import { InternalLink } from "src/ui/Link/InternalLink"

export function GuestChatMoreKnowledgeDialog({
  onClose,
}: {
  onClose: () => void
}) {
  const { tPlaceholder, t, langKeys } = useTranslate()

  return (
    <MDialog
      onClose={onClose}
      open={true}
      title={tPlaceholder("Needs more Knowledge to suggest answers")}
      onConfirm={onClose}
      confirmLabel={t(langKeys.close)}
      hideClose
    >
      <Text>
        {tPlaceholder(
          "Autopilot is missing the information it needs to create a suggestion. Help it improve by"
        )}{" "}
        <InternalLink to={Routes.AiAssistant.location()}>
          {tPlaceholder("adding more content")}
        </InternalLink>
        .
      </Text>
    </MDialog>
  )
}
